"use client";
export default function ErrorPage({ reset }: { reset: () => void }) {
  return (
    <div className="wrap empty-state" role="alert">
      <h1>دریافت اطلاعات ممکن نشد.</h1>
      <p>ارتباط با فروشگاه برقرار نیست. لطفاً دوباره تلاش کنید.</p>
      <button className="button primary" onClick={reset}>
        تلاش دوباره
      </button>
    </div>
  );
}
